// src/components/Home.jsx
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";

// بيانات الخدمات
const services = [
  {
    title: "Création d’entreprise",
    description:
      "Si vous envisagez de créer une entreprise au Maroc, CFJEXPERT vous propose : des informations précises, complètes et fiables pour vous aider à prendre les bonnes décisions, ainsi que des conseils sur la forme juridique la plus adaptée à votre activité afin d’assurer le succès de votre projet.",
    icon: "/icons/business.png",
  },
  {
    title: "Domiciliation",
    description:
      "Grâce à nos partenariats avec des centres d’affaires prestigieux, CFJEXPERT vous propose un service de domiciliation juridique dans des emplacements stratégiques et emblématiques des plus grandes villes du Maroc, y compris Casablanca et Rabat, afin d’assurer la crédibilité et le professionnalisme de votre projet.",
    icon: "/icons/domiciliation.png",
  },
  {
    title: "Travaux Juridiques",
    description:
      "L’équipe de conseillers juridiques de CFJEXPERT vous offre un accompagnement complet, incluant informations, conseils professionnels, assistance pratique et défense dans tous les domaines du droit commercial, afin de garantir la protection des intérêts de votre entreprise.",
    icon: "/icons/legal.png",
  },
];

// بيانات السلايدر الرئيسي
const mainSlides = [
  {
    title: "Optimisez Votre Gestion Administrative",
    subtitle: "Des solutions efficaces pour simplifier vos processus internes.",
    image: "/image/image66.jpg",
  },
  {
    title: "Gérez Vos Documents en Ligne",
    subtitle: "Un accès facile et sécurisé à tous vos fichiers.",
    image: "/image/image56.jpg",
  },
  {
    title: "Suivi Automatique des Projets",
    subtitle: "Restez informé en temps réel.",
    image: "/image/image45.jpg",
  },
];

// بيانات السلايدر الثاني (HeroSection)
const heroSliderImages = [
  "/image/Working girl.jpg",
  "/image/image77.jpg",
  "/image/Ranking Warriors in this Era.jpg",
];

// بيانات Testimonials
const testimonials = [
  {
    text: "Nous proposons des solutions innovantes et fiables, basées sur des ressources internes solides, tout en respectant les plus hauts standards de préparation digitale. Nous développons des compétences clés durables et tournées vers l’avenir, en offrant des expériences efficaces et à forte valeur ajoutée. Nous veillons également à intégrer les systèmes et solutions de manière cohérente afin de garantir des performances optimales et des résultats d’excellence",
    author: "JIMMY FERRARA. GENERAL MANAGER",
    img: "/image/t2.jpg",
  },
  {
    text: "Nous concevons des solutions innovantes et fiables, basées sur des compétences internes solides, tout en respectant les plus hauts standards d’excellence digitale afin de garantir une préparation complète aux exigences du web moderne",
    author: "PERRY ANDREWS. SWIFT Inc.",
    img: "/image/t1-res.jpg",
  },
  {
    text: "Nous développons des solutions innovantes et fiables, basées sur des ressources internes précises et naturelles, tout en respectant les plus hauts standards de préparation digitale afin de garantir une présence forte et efficace sur le web.",
    author: "SAMMY BROWNS. CFO, Perfect Inc.",
    img: "/image/t3-res.jpg",
  },
];

// TestimonialsSlider Component
function TestimonialsSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  const nextSlide = () => {
    setCurrentIndex((prev) =>
      prev === testimonials.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <section className="testimonials-section">
      <h2 className="testimonials-title">REVUES & TÉMOIGNAGES</h2>

      <div className="testimonial-card">
        <button className="arrow left" onClick={prevSlide} aria-label="Previous testimonial">
          &#10094;
        </button>

        <div className="testimonial-content">
          <div className="quote-mark left">“</div>
          <p className="testimonial-text">{testimonials[currentIndex].text}</p>
          <div className="quote-mark right">”</div>
          <hr className="testimonial-divider" />
          <div className="testimonial-author">
            <strong>{testimonials[currentIndex].author}</strong>
          </div>
        </div>

        <div className="testimonial-image">
          <img src={testimonials[currentIndex].img} alt={testimonials[currentIndex].author} />
        </div>

        <button className="arrow right" onClick={nextSlide} aria-label="Next testimonial">
          &#10095;
        </button>
      </div>

      <div className="dots">
        {testimonials.map((_, idx) => (
          <span
            key={idx}
            className={`dot ${idx === currentIndex ? "active" : ""}`}
            onClick={() => setCurrentIndex(idx)}
            aria-label={`Go to testimonial ${idx + 1}`}
          />
        ))}
      </div>
    </section>
  );
}

function ReferencesSlider() {
  const sliderRef = useRef(null);

  const logos = [
    "/image/4-logo-22.jpg",
    "/image/logo.jpg",
    "/image/paint-shop-logo-ideas-vector-37064803.jpg",
    "/images/logo4.png",
    "/images/logo5.png",
    "/images/logo6.png",
    "/images/logo7.png",
    "/images/logo8.png",
    "/images/logo9.png",
  ];

  useEffect(() => {
    const slider = sliderRef.current;
    let scrollAmount = 0;

    const interval = setInterval(() => {
      if (slider) {
        scrollAmount += 1;
        if (scrollAmount >= slider.scrollWidth / 2) {
          scrollAmount = 0;
        }
        slider.scrollLeft = scrollAmount;
      }
    }, 20);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="references-section">
      <h2>RÉFÉRENCES</h2>
      <div className="logos-slider" ref={sliderRef}>
        {[...logos, ...logos].map((logo, idx) => (
          <div className="logo-item" key={idx}>
            <img src={logo} alt={`Logo ${idx + 1}`} />
          </div>
        ))}
      </div>
    </section>
  );
}

// Home Component
function Home() {
  const navigate = useNavigate(); // React Router navigation
  const [currentMain, setCurrentMain] = useState(0);
  const [currentHero, setCurrentHero] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMain((prev) => (prev + 1) % mainSlides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentHero((prev) => (prev + 1) % heroSliderImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const { title, subtitle, image } = mainSlides[currentMain];

  return (
    <div className="home-container">

      {/* SLIDER الرئيسي */}
      <section className="hero">
        <div className="hero-left">
          <h1>{title}</h1>
          <p>{subtitle}</p>
          <div className="hero-buttons">
            <button className="btn-orange" onClick={() => navigate("/services")}>
              Nos Services
            </button>
            <button className="btn-white" onClick={() => navigate("/contact")}>
              Contactez-Nous
            </button>
          </div>
        </div>
        <div className="hero-right">
          <img src={image} alt="hero" className="hero-image" />
        </div>
      </section>

      {/* SECTION SERVICES */}
      <section className="services-section">
        <div className="services-header">
          <h2>Nos Services d’Excellence</h2>
          <p>
            CFJEXPERT propose une large gamme de solutions et de services conçus
            pour répondre aux besoins de votre entreprise.
          </p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-icon">
                <img src={service.icon} alt={service.title} />
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* HERO SECONDARY */}
      <section className="hero-secondary-section">
        <div className="hero-secondary-container">
          <div className="hero-secondary-left">
            <h1>
              Nous offrons une gamme complète de services
              <br />
              pour <span>tous les types d'entreprises.</span>
            </h1>
            <ul className="hero-secondary-services-list">
              <li>TRAVAUX DE COMPTABILITÉ</li>
              <li>COMMUNICATION</li>
              <li>FORMATION & SERVICES DIVERS</li>
            </ul>
            <button 
              className="hero-secondary-btn" 
              onClick={() => navigate("/services")}
            >
              Nos Services
            </button>
          </div>
          <div className="hero-secondary-right">
            <div className="hero-secondary-slider">
              {heroSliderImages.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt="slide"
                  className={index === currentHero ? "hero-secondary-slide active" : "hero-secondary-slide"}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* SECTION Pourquoi Nous */}
      <section className="pourquoi-nous">
        <div className="pourquoi-nous-left">
          <img src="/image/image90.jpg" alt="CFEXPERT Logo" className="logo-image" />
          <h2>Pourquoi Nous ?</h2>
        </div>
        <div className="pourquoi-nous-right">
          <h3>
            Pourquoi Créer Votre Entreprise Avec <span>CFJEXPERT</span> ?
          </h3>
          <p className="intro">
            Créer une société au Maroc n’est plus réservé aux grands ; quelle que soit l’ampleur de votre idée, il suffit de choisir le bon partenaire pour lui donner vie et transformer votre projet en succès.
          </p>
          <p className="details">
            <strong>CFJEXPERT</strong> aspire à être votre partenaire de confiance pour réussir, que vous soyez un entrepreneur ou un investisseur, marocain ou étranger. Nous mettons notre expertise et notre savoir-faire à votre disposition pour vous offrir des conseils précis, rapides et continus, afin de vous protéger contre tout risque juridique ou fiscal susceptible d’entraver votre projet et vos activités.
          </p>
        </div>
      </section>

      {/* SECTION CTA */}
      <section className="cta-section">
        <div className="cta-container">
          <div className="cta-card" onClick={() => navigate("/devis")}>
            <h2>Demander un Devis</h2>
            <p>Demandez Votre Devis<br />100% Gratuit !</p>
            <div className="cta-line"></div>
          </div>

          <div className="cta-card" onClick={() => navigate("/rappel")}>
            <h2>Demander un Rappel</h2>
            <p>Un de nos agents prendra<br />contact avec vous dans les 24h</p>
            <div className="cta-line"></div>
          </div>

          <div className="cta-card cta-card-bg" onClick={() => navigate("/packs")}>
            <h2>Télécharger Nos Packs</h2>
            <p>Téléchargez nos Packs & dernières offres de service</p>
            <div className="cta-line"></div>
          </div>
        </div>
      </section>

      {/* Testimonials Slider */}
      <TestimonialsSlider />

      {/* References Slider */}
      <ReferencesSlider />

    </div>
  );
}

export default Home;